// Generated proto-based client
// DO NOT EDIT: This file is auto-generated

import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient } from "@connectrpc/connect";
import type { PlainMessage } from "@bufbuild/protobuf";

// Admin Service imports
import { AdminService } from "../../proto/generated/service/admin/admin_service_connect";
import { AdminCRUDService } from "../../proto/generated/service/admin/crud/admin_crud_service_connect";

// Utility imports (静的ファイル)
import { HeaderUtils, TypeUtils, handleProtoError } from "../utils/ClientUtils";
import type { ProtoResponse } from "../utils/ClientUtils";
export { HeaderUtils, TypeUtils, handleProtoError };
export type { ProtoResponse };

// 環境情報を取得
import { getBaseUrl, shouldShowDebugLogs } from "../../config/EnvironmentConfig";

// Re-export entity types for external use (as PlainMessage for easier use)
export type EntityAdminUser = PlainMessage<EntityAdminUserProto>;
type EntityAdminUserProto = import("../../proto/generated/entity/admin_user_pb").AdminUser;
export type EntityAnnounce = PlainMessage<EntityAnnounceProto>;
type EntityAnnounceProto = import("../../proto/generated/entity/announce_pb").Announce;
export type EntityContact = PlainMessage<EntityContactProto>;
type EntityContactProto = import("../../proto/generated/entity/contact_pb").Contact;
export type EntityContactReadStatus = PlainMessage<EntityContactReadStatusProto>;
type EntityContactReadStatusProto = import("../../proto/generated/entity/contact_read_status_pb").ContactReadStatus;
export type EntityForceReload = PlainMessage<EntityForceReloadProto>;
type EntityForceReloadProto = import("../../proto/generated/entity/force_reload_pb").ForceReload;
export type EntityMaintenance = PlainMessage<EntityMaintenanceProto>;
type EntityMaintenanceProto = import("../../proto/generated/entity/maintenance_pb").Maintenance;
export type EntityResult = PlainMessage<EntityResultProto>;
type EntityResultProto = import("../../proto/generated/entity/result_pb").Result;
export type EntityResultCategory = PlainMessage<EntityResultCategoryProto>;
type EntityResultCategoryProto = import("../../proto/generated/entity/result_category_pb").ResultCategory;

// Re-export service types for convenience (as PlainMessage for easier use)
export type CreateAdminUserArgs = PlainMessage<CreateAdminUserArgsProto>;
export type CreateAdminUserReply = PlainMessage<CreateAdminUserReplyProto>;
export type CreateAnnounceArgs = PlainMessage<CreateAnnounceArgsProto>;
export type CreateAnnounceReply = PlainMessage<CreateAnnounceReplyProto>;
export type CreateContactArgs = PlainMessage<CreateContactArgsProto>;
export type CreateContactReply = PlainMessage<CreateContactReplyProto>;
export type CreateContactReadStatusArgs = PlainMessage<CreateContactReadStatusArgsProto>;
export type CreateContactReadStatusReply = PlainMessage<CreateContactReadStatusReplyProto>;
export type CreateForceReloadArgs = PlainMessage<CreateForceReloadArgsProto>;
export type CreateForceReloadReply = PlainMessage<CreateForceReloadReplyProto>;
export type CreateMaintenanceArgs = PlainMessage<CreateMaintenanceArgsProto>;
export type CreateMaintenanceReply = PlainMessage<CreateMaintenanceReplyProto>;
export type CreateResultArgs = PlainMessage<CreateResultArgsProto>;
export type CreateResultReply = PlainMessage<CreateResultReplyProto>;
export type CreateResultCategoryArgs = PlainMessage<CreateResultCategoryArgsProto>;
export type CreateResultCategoryReply = PlainMessage<CreateResultCategoryReplyProto>;
export type DeleteAdminUserArgs = PlainMessage<DeleteAdminUserArgsProto>;
export type DeleteAdminUserReply = PlainMessage<DeleteAdminUserReplyProto>;
export type DeleteAnnounceArgs = PlainMessage<DeleteAnnounceArgsProto>;
export type DeleteAnnounceReply = PlainMessage<DeleteAnnounceReplyProto>;
export type DeleteContactArgs = PlainMessage<DeleteContactArgsProto>;
export type DeleteContactReply = PlainMessage<DeleteContactReplyProto>;
export type DeleteContactReadStatusArgs = PlainMessage<DeleteContactReadStatusArgsProto>;
export type DeleteContactReadStatusReply = PlainMessage<DeleteContactReadStatusReplyProto>;
export type DeleteForceReloadArgs = PlainMessage<DeleteForceReloadArgsProto>;
export type DeleteForceReloadReply = PlainMessage<DeleteForceReloadReplyProto>;
export type DeleteMaintenanceArgs = PlainMessage<DeleteMaintenanceArgsProto>;
export type DeleteMaintenanceReply = PlainMessage<DeleteMaintenanceReplyProto>;
export type DeleteResultArgs = PlainMessage<DeleteResultArgsProto>;
export type DeleteResultReply = PlainMessage<DeleteResultReplyProto>;
export type DeleteResultCategoryArgs = PlainMessage<DeleteResultCategoryArgsProto>;
export type DeleteResultCategoryReply = PlainMessage<DeleteResultCategoryReplyProto>;
export type IndexAdminUserArgs = PlainMessage<IndexAdminUserArgsProto>;
export type IndexAdminUserReply = PlainMessage<IndexAdminUserReplyProto>;
export type IndexAnnounceArgs = PlainMessage<IndexAnnounceArgsProto>;
export type IndexAnnounceReply = PlainMessage<IndexAnnounceReplyProto>;
export type IndexContactArgs = PlainMessage<IndexContactArgsProto>;
export type IndexContactReply = PlainMessage<IndexContactReplyProto>;
export type IndexContactReadStatusArgs = PlainMessage<IndexContactReadStatusArgsProto>;
export type IndexContactReadStatusReply = PlainMessage<IndexContactReadStatusReplyProto>;
export type IndexForceReloadArgs = PlainMessage<IndexForceReloadArgsProto>;
export type IndexForceReloadReply = PlainMessage<IndexForceReloadReplyProto>;
export type IndexMaintenanceArgs = PlainMessage<IndexMaintenanceArgsProto>;
export type IndexMaintenanceReply = PlainMessage<IndexMaintenanceReplyProto>;
export type IndexResultArgs = PlainMessage<IndexResultArgsProto>;
export type IndexResultReply = PlainMessage<IndexResultReplyProto>;
export type IndexResultCategoryArgs = PlainMessage<IndexResultCategoryArgsProto>;
export type IndexResultCategoryReply = PlainMessage<IndexResultCategoryReplyProto>;
export type ReadAdminUserArgs = PlainMessage<ReadAdminUserArgsProto>;
export type ReadAdminUserReply = PlainMessage<ReadAdminUserReplyProto>;
export type ReadAnnounceArgs = PlainMessage<ReadAnnounceArgsProto>;
export type ReadAnnounceReply = PlainMessage<ReadAnnounceReplyProto>;
export type ReadContactArgs = PlainMessage<ReadContactArgsProto>;
export type ReadContactReply = PlainMessage<ReadContactReplyProto>;
export type ReadContactReadStatusArgs = PlainMessage<ReadContactReadStatusArgsProto>;
export type ReadContactReadStatusReply = PlainMessage<ReadContactReadStatusReplyProto>;
export type ReadForceReloadArgs = PlainMessage<ReadForceReloadArgsProto>;
export type ReadForceReloadReply = PlainMessage<ReadForceReloadReplyProto>;
export type ReadMaintenanceArgs = PlainMessage<ReadMaintenanceArgsProto>;
export type ReadMaintenanceReply = PlainMessage<ReadMaintenanceReplyProto>;
export type ReadResultArgs = PlainMessage<ReadResultArgsProto>;
export type ReadResultReply = PlainMessage<ReadResultReplyProto>;
export type ReadResultCategoryArgs = PlainMessage<ReadResultCategoryArgsProto>;
export type ReadResultCategoryReply = PlainMessage<ReadResultCategoryReplyProto>;
export type UpdateAdminUserArgs = PlainMessage<UpdateAdminUserArgsProto>;
export type UpdateAdminUserReply = PlainMessage<UpdateAdminUserReplyProto>;
export type UpdateAnnounceArgs = PlainMessage<UpdateAnnounceArgsProto>;
export type UpdateAnnounceReply = PlainMessage<UpdateAnnounceReplyProto>;
export type UpdateContactArgs = PlainMessage<UpdateContactArgsProto>;
export type UpdateContactReply = PlainMessage<UpdateContactReplyProto>;
export type UpdateContactReadStatusArgs = PlainMessage<UpdateContactReadStatusArgsProto>;
export type UpdateContactReadStatusReply = PlainMessage<UpdateContactReadStatusReplyProto>;
export type UpdateForceReloadArgs = PlainMessage<UpdateForceReloadArgsProto>;
export type UpdateForceReloadReply = PlainMessage<UpdateForceReloadReplyProto>;
export type UpdateMaintenanceArgs = PlainMessage<UpdateMaintenanceArgsProto>;
export type UpdateMaintenanceReply = PlainMessage<UpdateMaintenanceReplyProto>;
export type UpdateResultArgs = PlainMessage<UpdateResultArgsProto>;
export type UpdateResultReply = PlainMessage<UpdateResultReplyProto>;
export type UpdateResultCategoryArgs = PlainMessage<UpdateResultCategoryArgsProto>;
export type UpdateResultCategoryReply = PlainMessage<UpdateResultCategoryReplyProto>;
export type AdminAddCompositeIndexArgs = PlainMessage<AdminAddCompositeIndexArgsProto>;
export type AdminAddCompositeIndexReply = PlainMessage<AdminAddCompositeIndexReplyProto>;
export type AdminAddIndexArgs = PlainMessage<AdminAddIndexArgsProto>;
export type AdminAddIndexReply = PlainMessage<AdminAddIndexReplyProto>;
export type ChangePasswordArgs = PlainMessage<ChangePasswordArgsProto>;
export type ChangePasswordReply = PlainMessage<ChangePasswordReplyProto>;
export type CreateAdminUserWithPasswordArgs = PlainMessage<CreateAdminUserWithPasswordArgsProto>;
export type CreateAdminUserWithPasswordReply = PlainMessage<CreateAdminUserWithPasswordReplyProto>;
export type DeleteAnnounceMediaArgs = PlainMessage<DeleteAnnounceMediaArgsProto>;
export type DeleteAnnounceMediaReply = PlainMessage<DeleteAnnounceMediaReplyProto>;
export type DeleteResultMediaArgs = PlainMessage<DeleteResultMediaArgsProto>;
export type DeleteResultMediaReply = PlainMessage<DeleteResultMediaReplyProto>;
export type AdminDropColumnArgs = PlainMessage<AdminDropColumnArgsProto>;
export type AdminDropColumnReply = PlainMessage<AdminDropColumnReplyProto>;
export type AdminDropCompositeIndexArgs = PlainMessage<AdminDropCompositeIndexArgsProto>;
export type AdminDropCompositeIndexReply = PlainMessage<AdminDropCompositeIndexReplyProto>;
export type AdminDropIndexArgs = PlainMessage<AdminDropIndexArgsProto>;
export type AdminDropIndexReply = PlainMessage<AdminDropIndexReplyProto>;
export type GetUnreadContactCountArgs = PlainMessage<GetUnreadContactCountArgsProto>;
export type GetUnreadContactCountReply = PlainMessage<GetUnreadContactCountReplyProto>;
export type AdminHealthCheckArgs = PlainMessage<AdminHealthCheckArgsProto>;
export type AdminHealthCheckReply = PlainMessage<AdminHealthCheckReplyProto>;
export type LoginAdminArgs = PlainMessage<LoginAdminArgsProto>;
export type LoginAdminReply = PlainMessage<LoginAdminReplyProto>;
export type MarkContactAsReadArgs = PlainMessage<MarkContactAsReadArgsProto>;
export type MarkContactAsReadReply = PlainMessage<MarkContactAsReadReplyProto>;
export type MarkContactAsUnreadArgs = PlainMessage<MarkContactAsUnreadArgsProto>;
export type MarkContactAsUnreadReply = PlainMessage<MarkContactAsUnreadReplyProto>;
export type PublishStagingToProductionArgs = PlainMessage<PublishStagingToProductionArgsProto>;
export type PublishStagingToProductionReply = PlainMessage<PublishStagingToProductionReplyProto>;
export type UpdateAdminUserProfileArgs = PlainMessage<UpdateAdminUserProfileArgsProto>;
export type UpdateAdminUserProfileReply = PlainMessage<UpdateAdminUserProfileReplyProto>;
export type UploadAnnounceMediaArgs = PlainMessage<UploadAnnounceMediaArgsProto>;
export type UploadAnnounceMediaReply = PlainMessage<UploadAnnounceMediaReplyProto>;
export type UploadResultCategoryThumbnailArgs = PlainMessage<UploadResultCategoryThumbnailArgsProto>;
export type UploadResultCategoryThumbnailReply = PlainMessage<UploadResultCategoryThumbnailReplyProto>;
export type UploadResultMediaArgs = PlainMessage<UploadResultMediaArgsProto>;
export type UploadResultMediaReply = PlainMessage<UploadResultMediaReplyProto>;

// Proto types (for internal use)
type CreateAdminUserArgsProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").CreateAdminUserArgs;
type CreateAdminUserReplyProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").CreateAdminUserReply;
type CreateAnnounceArgsProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").CreateAnnounceArgs;
type CreateAnnounceReplyProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").CreateAnnounceReply;
type CreateContactArgsProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").CreateContactArgs;
type CreateContactReplyProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").CreateContactReply;
type CreateContactReadStatusArgsProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").CreateContactReadStatusArgs;
type CreateContactReadStatusReplyProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").CreateContactReadStatusReply;
type CreateForceReloadArgsProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").CreateForceReloadArgs;
type CreateForceReloadReplyProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").CreateForceReloadReply;
type CreateMaintenanceArgsProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").CreateMaintenanceArgs;
type CreateMaintenanceReplyProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").CreateMaintenanceReply;
type CreateResultArgsProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").CreateResultArgs;
type CreateResultReplyProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").CreateResultReply;
type CreateResultCategoryArgsProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").CreateResultCategoryArgs;
type CreateResultCategoryReplyProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").CreateResultCategoryReply;
type DeleteAdminUserArgsProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").DeleteAdminUserArgs;
type DeleteAdminUserReplyProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").DeleteAdminUserReply;
type DeleteAnnounceArgsProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").DeleteAnnounceArgs;
type DeleteAnnounceReplyProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").DeleteAnnounceReply;
type DeleteContactArgsProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").DeleteContactArgs;
type DeleteContactReplyProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").DeleteContactReply;
type DeleteContactReadStatusArgsProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").DeleteContactReadStatusArgs;
type DeleteContactReadStatusReplyProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").DeleteContactReadStatusReply;
type DeleteForceReloadArgsProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").DeleteForceReloadArgs;
type DeleteForceReloadReplyProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").DeleteForceReloadReply;
type DeleteMaintenanceArgsProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").DeleteMaintenanceArgs;
type DeleteMaintenanceReplyProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").DeleteMaintenanceReply;
type DeleteResultArgsProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").DeleteResultArgs;
type DeleteResultReplyProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").DeleteResultReply;
type DeleteResultCategoryArgsProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").DeleteResultCategoryArgs;
type DeleteResultCategoryReplyProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").DeleteResultCategoryReply;
type IndexAdminUserArgsProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").IndexAdminUserArgs;
type IndexAdminUserReplyProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").IndexAdminUserReply;
type IndexAnnounceArgsProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").IndexAnnounceArgs;
type IndexAnnounceReplyProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").IndexAnnounceReply;
type IndexContactArgsProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").IndexContactArgs;
type IndexContactReplyProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").IndexContactReply;
type IndexContactReadStatusArgsProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").IndexContactReadStatusArgs;
type IndexContactReadStatusReplyProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").IndexContactReadStatusReply;
type IndexForceReloadArgsProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").IndexForceReloadArgs;
type IndexForceReloadReplyProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").IndexForceReloadReply;
type IndexMaintenanceArgsProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").IndexMaintenanceArgs;
type IndexMaintenanceReplyProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").IndexMaintenanceReply;
type IndexResultArgsProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").IndexResultArgs;
type IndexResultReplyProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").IndexResultReply;
type IndexResultCategoryArgsProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").IndexResultCategoryArgs;
type IndexResultCategoryReplyProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").IndexResultCategoryReply;
type ReadAdminUserArgsProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").ReadAdminUserArgs;
type ReadAdminUserReplyProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").ReadAdminUserReply;
type ReadAnnounceArgsProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").ReadAnnounceArgs;
type ReadAnnounceReplyProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").ReadAnnounceReply;
type ReadContactArgsProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").ReadContactArgs;
type ReadContactReplyProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").ReadContactReply;
type ReadContactReadStatusArgsProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").ReadContactReadStatusArgs;
type ReadContactReadStatusReplyProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").ReadContactReadStatusReply;
type ReadForceReloadArgsProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").ReadForceReloadArgs;
type ReadForceReloadReplyProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").ReadForceReloadReply;
type ReadMaintenanceArgsProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").ReadMaintenanceArgs;
type ReadMaintenanceReplyProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").ReadMaintenanceReply;
type ReadResultArgsProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").ReadResultArgs;
type ReadResultReplyProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").ReadResultReply;
type ReadResultCategoryArgsProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").ReadResultCategoryArgs;
type ReadResultCategoryReplyProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").ReadResultCategoryReply;
type UpdateAdminUserArgsProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").UpdateAdminUserArgs;
type UpdateAdminUserReplyProto = import("../../proto/generated/service/admin/crud/admin_user_crud_service_generated_pb").UpdateAdminUserReply;
type UpdateAnnounceArgsProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").UpdateAnnounceArgs;
type UpdateAnnounceReplyProto = import("../../proto/generated/service/admin/crud/announce_crud_service_generated_pb").UpdateAnnounceReply;
type UpdateContactArgsProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").UpdateContactArgs;
type UpdateContactReplyProto = import("../../proto/generated/service/admin/crud/contact_crud_service_generated_pb").UpdateContactReply;
type UpdateContactReadStatusArgsProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").UpdateContactReadStatusArgs;
type UpdateContactReadStatusReplyProto = import("../../proto/generated/service/admin/crud/contact_read_status_crud_service_generated_pb").UpdateContactReadStatusReply;
type UpdateForceReloadArgsProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").UpdateForceReloadArgs;
type UpdateForceReloadReplyProto = import("../../proto/generated/service/admin/crud/force_reload_crud_service_generated_pb").UpdateForceReloadReply;
type UpdateMaintenanceArgsProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").UpdateMaintenanceArgs;
type UpdateMaintenanceReplyProto = import("../../proto/generated/service/admin/crud/maintenance_crud_service_generated_pb").UpdateMaintenanceReply;
type UpdateResultArgsProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").UpdateResultArgs;
type UpdateResultReplyProto = import("../../proto/generated/service/admin/crud/result_crud_service_generated_pb").UpdateResultReply;
type UpdateResultCategoryArgsProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").UpdateResultCategoryArgs;
type UpdateResultCategoryReplyProto = import("../../proto/generated/service/admin/crud/result_category_crud_service_generated_pb").UpdateResultCategoryReply;
type AdminAddCompositeIndexArgsProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminAddCompositeIndexArgs;
type AdminAddCompositeIndexReplyProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminAddCompositeIndexReply;
type AdminAddIndexArgsProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminAddIndexArgs;
type AdminAddIndexReplyProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminAddIndexReply;
type ChangePasswordArgsProto = import("../../proto/generated/service/admin/auth_service_pb").ChangePasswordArgs;
type ChangePasswordReplyProto = import("../../proto/generated/service/admin/auth_service_pb").ChangePasswordReply;
type CreateAdminUserWithPasswordArgsProto = import("../../proto/generated/service/admin/auth_service_pb").CreateAdminUserWithPasswordArgs;
type CreateAdminUserWithPasswordReplyProto = import("../../proto/generated/service/admin/auth_service_pb").CreateAdminUserWithPasswordReply;
type DeleteAnnounceMediaArgsProto = import("../../proto/generated/service/admin/announce_media_service_pb").DeleteAnnounceMediaArgs;
type DeleteAnnounceMediaReplyProto = import("../../proto/generated/service/admin/announce_media_service_pb").DeleteAnnounceMediaReply;
type DeleteResultMediaArgsProto = import("../../proto/generated/service/admin/result_media_service_pb").DeleteResultMediaArgs;
type DeleteResultMediaReplyProto = import("../../proto/generated/service/admin/result_media_service_pb").DeleteResultMediaReply;
type AdminDropColumnArgsProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropColumnArgs;
type AdminDropColumnReplyProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropColumnReply;
type AdminDropCompositeIndexArgsProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropCompositeIndexArgs;
type AdminDropCompositeIndexReplyProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropCompositeIndexReply;
type AdminDropIndexArgsProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropIndexArgs;
type AdminDropIndexReplyProto = import("../../proto/generated/service/admin/db_migration_service_pb").AdminDropIndexReply;
type GetUnreadContactCountArgsProto = import("../../proto/generated/service/admin/contact_service_pb").GetUnreadContactCountArgs;
type GetUnreadContactCountReplyProto = import("../../proto/generated/service/admin/contact_service_pb").GetUnreadContactCountReply;
type AdminHealthCheckArgsProto = import("../../proto/generated/service/admin/health_check_admin_service_pb").AdminHealthCheckArgs;
type AdminHealthCheckReplyProto = import("../../proto/generated/service/admin/health_check_admin_service_pb").AdminHealthCheckReply;
type LoginAdminArgsProto = import("../../proto/generated/service/admin/auth_service_pb").LoginAdminArgs;
type LoginAdminReplyProto = import("../../proto/generated/service/admin/auth_service_pb").LoginAdminReply;
type MarkContactAsReadArgsProto = import("../../proto/generated/service/admin/contact_service_pb").MarkContactAsReadArgs;
type MarkContactAsReadReplyProto = import("../../proto/generated/service/admin/contact_service_pb").MarkContactAsReadReply;
type MarkContactAsUnreadArgsProto = import("../../proto/generated/service/admin/contact_service_pb").MarkContactAsUnreadArgs;
type MarkContactAsUnreadReplyProto = import("../../proto/generated/service/admin/contact_service_pb").MarkContactAsUnreadReply;
type PublishStagingToProductionArgsProto = import("../../proto/generated/service/admin/publish_service_pb").PublishStagingToProductionArgs;
type PublishStagingToProductionReplyProto = import("../../proto/generated/service/admin/publish_service_pb").PublishStagingToProductionReply;
type UpdateAdminUserProfileArgsProto = import("../../proto/generated/service/admin/auth_service_pb").UpdateAdminUserProfileArgs;
type UpdateAdminUserProfileReplyProto = import("../../proto/generated/service/admin/auth_service_pb").UpdateAdminUserProfileReply;
type UploadAnnounceMediaArgsProto = import("../../proto/generated/service/admin/announce_media_service_pb").UploadAnnounceMediaArgs;
type UploadAnnounceMediaReplyProto = import("../../proto/generated/service/admin/announce_media_service_pb").UploadAnnounceMediaReply;
type UploadResultCategoryThumbnailArgsProto = import("../../proto/generated/service/admin/result_media_service_pb").UploadResultCategoryThumbnailArgs;
type UploadResultCategoryThumbnailReplyProto = import("../../proto/generated/service/admin/result_media_service_pb").UploadResultCategoryThumbnailReply;
type UploadResultMediaArgsProto = import("../../proto/generated/service/admin/result_media_service_pb").UploadResultMediaArgs;
type UploadResultMediaReplyProto = import("../../proto/generated/service/admin/result_media_service_pb").UploadResultMediaReply;

// Create transport with automatic header injection
const transport = createConnectTransport({
  baseUrl: getBaseUrl(),
  interceptors: [
    (next) => async (req) => {
      const customHeaders = HeaderUtils.generateRequestHeaders();
      for (const [key, value] of Object.entries(customHeaders)) {
        req.header.set(key, value);
      }
      return await next(req);
    },
  ],
});

// Create clients
const adminServiceClient = createClient(AdminService, transport);
const adminCRUDServiceClient = createClient(AdminCRUDService, transport);

// Unified Admin Client (AdminService + AdminCRUDService を統合)
export const AdminClient = {
  // CreateAdminUser AdminUser作成
  async CreateAdminUser(data: Partial<CreateAdminUserArgs>): Promise<ProtoResponse<CreateAdminUserReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateAdminUser Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createAdminUser(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateAdminUser Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateAnnounce Announce作成
  async CreateAnnounce(data: Partial<CreateAnnounceArgs>): Promise<ProtoResponse<CreateAnnounceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateAnnounce Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createAnnounce(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateAnnounce Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateContact Contact作成
  async CreateContact(data: Partial<CreateContactArgs>): Promise<ProtoResponse<CreateContactReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateContact Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createContact(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateContact Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateContactReadStatus ContactReadStatus作成
  async CreateContactReadStatus(data: Partial<CreateContactReadStatusArgs>): Promise<ProtoResponse<CreateContactReadStatusReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateContactReadStatus Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createContactReadStatus(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateContactReadStatus Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateForceReload ForceReload作成
  async CreateForceReload(data: Partial<CreateForceReloadArgs>): Promise<ProtoResponse<CreateForceReloadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateForceReload Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createForceReload(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateForceReload Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateMaintenance Maintenance作成
  async CreateMaintenance(data: Partial<CreateMaintenanceArgs>): Promise<ProtoResponse<CreateMaintenanceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateMaintenance Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createMaintenance(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateMaintenance Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateResult Result作成
  async CreateResult(data: Partial<CreateResultArgs>): Promise<ProtoResponse<CreateResultReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateResult Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createResult(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateResult Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateResultCategory ResultCategory作成
  async CreateResultCategory(data: Partial<CreateResultCategoryArgs>): Promise<ProtoResponse<CreateResultCategoryReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateResultCategory Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.createResultCategory(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateResultCategory Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteAdminUser AdminUser削除
  async DeleteAdminUser(data: Partial<DeleteAdminUserArgs>): Promise<ProtoResponse<DeleteAdminUserReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteAdminUser Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteAdminUser(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteAdminUser Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteAnnounce Announce削除
  async DeleteAnnounce(data: Partial<DeleteAnnounceArgs>): Promise<ProtoResponse<DeleteAnnounceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteAnnounce Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteAnnounce(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteAnnounce Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteContact Contact削除
  async DeleteContact(data: Partial<DeleteContactArgs>): Promise<ProtoResponse<DeleteContactReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteContact Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteContact(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteContact Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteContactReadStatus ContactReadStatus削除
  async DeleteContactReadStatus(data: Partial<DeleteContactReadStatusArgs>): Promise<ProtoResponse<DeleteContactReadStatusReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteContactReadStatus Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteContactReadStatus(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteContactReadStatus Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteForceReload ForceReload削除
  async DeleteForceReload(data: Partial<DeleteForceReloadArgs>): Promise<ProtoResponse<DeleteForceReloadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteForceReload Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteForceReload(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteForceReload Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteMaintenance Maintenance削除
  async DeleteMaintenance(data: Partial<DeleteMaintenanceArgs>): Promise<ProtoResponse<DeleteMaintenanceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteMaintenance Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteMaintenance(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteMaintenance Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteResult Result削除
  async DeleteResult(data: Partial<DeleteResultArgs>): Promise<ProtoResponse<DeleteResultReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteResult Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteResult(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteResult Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteResultCategory ResultCategory削除
  async DeleteResultCategory(data: Partial<DeleteResultCategoryArgs>): Promise<ProtoResponse<DeleteResultCategoryReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteResultCategory Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.deleteResultCategory(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteResultCategory Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexAdminUser AdminUser一覧取得（Index）
  async IndexAdminUser(data: Partial<IndexAdminUserArgs>): Promise<ProtoResponse<IndexAdminUserReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexAdminUser Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexAdminUser(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexAdminUser Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexAnnounce Announce一覧取得（Index） Admin の一覧には staging（編集中・未公開）と production（公開済み）の 両方を表示する。同じ ID の staging が存在する場合は staging を優先表示する （public ページからは production のみが見えるため、staging 側が「最新の編集状態」）。
  async IndexAnnounce(data: Partial<IndexAnnounceArgs>): Promise<ProtoResponse<IndexAnnounceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexAnnounce Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexAnnounce(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexAnnounce Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexContact Contact一覧取得（Index）
  async IndexContact(data: Partial<IndexContactArgs>): Promise<ProtoResponse<IndexContactReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexContact Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexContact(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexContact Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexContactReadStatus ContactReadStatus一覧取得（Index）
  async IndexContactReadStatus(data: Partial<IndexContactReadStatusArgs>): Promise<ProtoResponse<IndexContactReadStatusReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexContactReadStatus Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexContactReadStatus(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexContactReadStatus Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexForceReload ForceReload一覧取得（Index）
  async IndexForceReload(data: Partial<IndexForceReloadArgs>): Promise<ProtoResponse<IndexForceReloadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexForceReload Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexForceReload(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexForceReload Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexMaintenance Maintenance一覧取得（Index）
  async IndexMaintenance(data: Partial<IndexMaintenanceArgs>): Promise<ProtoResponse<IndexMaintenanceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexMaintenance Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexMaintenance(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexMaintenance Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexResult Result一覧取得（Index） Admin の一覧には staging（編集中・未公開）と production（公開済み）の 両方を表示する。同じ ID の staging が存在する場合は staging を優先する。
  async IndexResult(data: Partial<IndexResultArgs>): Promise<ProtoResponse<IndexResultReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexResult Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexResult(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexResult Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // IndexResultCategory ResultCategory一覧取得（Index） Admin の一覧には staging（編集中・未公開）と production（公開済み）の 両方を表示する。同じ ID の staging が存在する場合は staging を優先する。
  async IndexResultCategory(data: Partial<IndexResultCategoryArgs>): Promise<ProtoResponse<IndexResultCategoryReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 IndexResultCategory Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.indexResultCategory(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ IndexResultCategory Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadAdminUser AdminUser読み取り
  async ReadAdminUser(data: Partial<ReadAdminUserArgs>): Promise<ProtoResponse<ReadAdminUserReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadAdminUser Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readAdminUser(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadAdminUser Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadAnnounce Announce読み取り
  async ReadAnnounce(data: Partial<ReadAnnounceArgs>): Promise<ProtoResponse<ReadAnnounceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadAnnounce Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readAnnounce(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadAnnounce Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadContact Contact読み取り
  async ReadContact(data: Partial<ReadContactArgs>): Promise<ProtoResponse<ReadContactReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadContact Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readContact(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadContact Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadContactReadStatus ContactReadStatus読み取り
  async ReadContactReadStatus(data: Partial<ReadContactReadStatusArgs>): Promise<ProtoResponse<ReadContactReadStatusReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadContactReadStatus Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readContactReadStatus(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadContactReadStatus Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadForceReload ForceReload読み取り
  async ReadForceReload(data: Partial<ReadForceReloadArgs>): Promise<ProtoResponse<ReadForceReloadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadForceReload Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readForceReload(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadForceReload Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadMaintenance Maintenance読み取り
  async ReadMaintenance(data: Partial<ReadMaintenanceArgs>): Promise<ProtoResponse<ReadMaintenanceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadMaintenance Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readMaintenance(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadMaintenance Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadResult Result読み取り
  async ReadResult(data: Partial<ReadResultArgs>): Promise<ProtoResponse<ReadResultReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadResult Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readResult(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadResult Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ReadResultCategory ResultCategory読み取り
  async ReadResultCategory(data: Partial<ReadResultCategoryArgs>): Promise<ProtoResponse<ReadResultCategoryReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ReadResultCategory Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.readResultCategory(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ReadResultCategory Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateAdminUser AdminUser更新
  async UpdateAdminUser(data: Partial<UpdateAdminUserArgs>): Promise<ProtoResponse<UpdateAdminUserReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateAdminUser Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateAdminUser(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateAdminUser Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateAnnounce Announce更新
  async UpdateAnnounce(data: Partial<UpdateAnnounceArgs>): Promise<ProtoResponse<UpdateAnnounceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateAnnounce Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateAnnounce(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateAnnounce Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateContact Contact更新
  async UpdateContact(data: Partial<UpdateContactArgs>): Promise<ProtoResponse<UpdateContactReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateContact Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateContact(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateContact Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateContactReadStatus ContactReadStatus更新
  async UpdateContactReadStatus(data: Partial<UpdateContactReadStatusArgs>): Promise<ProtoResponse<UpdateContactReadStatusReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateContactReadStatus Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateContactReadStatus(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateContactReadStatus Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateForceReload ForceReload更新
  async UpdateForceReload(data: Partial<UpdateForceReloadArgs>): Promise<ProtoResponse<UpdateForceReloadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateForceReload Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateForceReload(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateForceReload Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateMaintenance Maintenance更新
  async UpdateMaintenance(data: Partial<UpdateMaintenanceArgs>): Promise<ProtoResponse<UpdateMaintenanceReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateMaintenance Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateMaintenance(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateMaintenance Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateResult Result更新
  async UpdateResult(data: Partial<UpdateResultArgs>): Promise<ProtoResponse<UpdateResultReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateResult Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateResult(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateResult Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateResultCategory ResultCategory更新
  async UpdateResultCategory(data: Partial<UpdateResultCategoryArgs>): Promise<ProtoResponse<UpdateResultCategoryReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateResultCategory Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminCRUDServiceClient.updateResultCategory(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateResultCategory Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // AddCompositeIndex 複合インデックスを追加（全体メンテナンス中のみ実行可能）
  async AddCompositeIndex(data: Partial<AdminAddCompositeIndexArgs>): Promise<ProtoResponse<AdminAddCompositeIndexReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 AddCompositeIndex Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.addCompositeIndex(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ AddCompositeIndex Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // AddIndex インデックスを追加（全体メンテナンス中のみ実行可能）
  async AddIndex(data: Partial<AdminAddIndexArgs>): Promise<ProtoResponse<AdminAddIndexReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 AddIndex Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.addIndex(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ AddIndex Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // ChangePassword パスワード変更
  async ChangePassword(data: Partial<ChangePasswordArgs>): Promise<ProtoResponse<ChangePasswordReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 ChangePassword Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.changePassword(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ ChangePassword Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // CreateAdminUserWithPassword 平文パスワードを bcrypt ハッシュ化して管理ユーザーを作成する。 既に同じメールアドレスの管理ユーザーが存在する場合はエラーを返す。
  async CreateAdminUserWithPassword(data: Partial<CreateAdminUserWithPasswordArgs>): Promise<ProtoResponse<CreateAdminUserWithPasswordReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 CreateAdminUserWithPassword Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.createAdminUserWithPassword(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ CreateAdminUserWithPassword Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteAnnounceMedia お知らせメディアを削除（AdminServiceメソッド）
  async DeleteAnnounceMedia(data: Partial<DeleteAnnounceMediaArgs>): Promise<ProtoResponse<DeleteAnnounceMediaReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteAnnounceMedia Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.deleteAnnounceMedia(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteAnnounceMedia Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DeleteResultMedia 施工実績メディアを削除（AdminServiceメソッド）
  async DeleteResultMedia(data: Partial<DeleteResultMediaArgs>): Promise<ProtoResponse<DeleteResultMediaReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DeleteResultMedia Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.deleteResultMedia(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DeleteResultMedia Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DropColumn カラムを削除（全体メンテナンス中のみ実行可能）
  async DropColumn(data: Partial<AdminDropColumnArgs>): Promise<ProtoResponse<AdminDropColumnReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DropColumn Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.dropColumn(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DropColumn Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DropCompositeIndex 複合インデックスを削除（全体メンテナンス中のみ実行可能）
  async DropCompositeIndex(data: Partial<AdminDropCompositeIndexArgs>): Promise<ProtoResponse<AdminDropCompositeIndexReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DropCompositeIndex Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.dropCompositeIndex(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DropCompositeIndex Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // DropIndex インデックスを削除（全体メンテナンス中のみ実行可能）
  async DropIndex(data: Partial<AdminDropIndexArgs>): Promise<ProtoResponse<AdminDropIndexReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 DropIndex Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.dropIndex(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ DropIndex Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // GetUnreadContactCount 未読お問い合わせ数を取得 既読状態はお問い合わせ自体が持つため、管理ユーザー間で共有される。
  async GetUnreadContactCount(data: Partial<GetUnreadContactCountArgs>): Promise<ProtoResponse<GetUnreadContactCountReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 GetUnreadContactCount Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.getUnreadContactCount(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ GetUnreadContactCount Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // HealthCheck システム状態を取得（AdminServiceメソッド）
  async HealthCheck(data: Partial<AdminHealthCheckArgs>): Promise<ProtoResponse<AdminHealthCheckReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 HealthCheck Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.healthCheck(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ HealthCheck Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // LoginAdmin 管理ユーザーログイン
  async LoginAdmin(data: Partial<LoginAdminArgs>): Promise<ProtoResponse<LoginAdminReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 LoginAdmin Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.loginAdmin(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ LoginAdmin Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // MarkContactAsRead お問い合わせを既読にする
  async MarkContactAsRead(data: Partial<MarkContactAsReadArgs>): Promise<ProtoResponse<MarkContactAsReadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 MarkContactAsRead Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.markContactAsRead(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ MarkContactAsRead Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // MarkContactAsUnread お問い合わせを未読に戻す
  async MarkContactAsUnread(data: Partial<MarkContactAsUnreadArgs>): Promise<ProtoResponse<MarkContactAsUnreadReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 MarkContactAsUnread Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.markContactAsUnread(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ MarkContactAsUnread Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // PublishStagingToProduction staging 環境の全エンティティを production に反映する。 各エンティティ種別について以下を実行する:  1. 現在の本番(production)レコードを削除  2. staging レコードを production にコピー（環境フラグを書き換えて保存）  /preview で確認した状態がそのまま本番に反映される。
  async PublishStagingToProduction(data: Partial<PublishStagingToProductionArgs>): Promise<ProtoResponse<PublishStagingToProductionReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 PublishStagingToProduction Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.publishStagingToProduction(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ PublishStagingToProduction Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UpdateAdminUserProfile 管理ユーザーの表示名、デバッグフラグ、パスワードを更新する。 パスワードは指定されたときだけ bcrypt で再ハッシュして上書きする。
  async UpdateAdminUserProfile(data: Partial<UpdateAdminUserProfileArgs>): Promise<ProtoResponse<UpdateAdminUserProfileReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UpdateAdminUserProfile Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.updateAdminUserProfile(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UpdateAdminUserProfile Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UploadAnnounceMedia お知らせメディアをアップロード（AdminServiceメソッド）
  async UploadAnnounceMedia(data: Partial<UploadAnnounceMediaArgs>): Promise<ProtoResponse<UploadAnnounceMediaReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UploadAnnounceMedia Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.uploadAnnounceMedia(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UploadAnnounceMedia Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UploadResultCategoryThumbnail カテゴリサムネイル画像を R2 + ローカルキャッシュへ保存する。 既存の UploadResultMedia と同等の処理を、usage="result-category" で実行。
  async UploadResultCategoryThumbnail(data: Partial<UploadResultCategoryThumbnailArgs>): Promise<ProtoResponse<UploadResultCategoryThumbnailReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UploadResultCategoryThumbnail Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.uploadResultCategoryThumbnail(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UploadResultCategoryThumbnail Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
  // UploadResultMedia 施工実績メディアをアップロード（AdminServiceメソッド）
  async UploadResultMedia(data: Partial<UploadResultMediaArgs>): Promise<ProtoResponse<UploadResultMediaReply>> {
    try {
      const preparedData = TypeUtils.prepareForSend(data);
      
      if (shouldShowDebugLogs()) {
        console.group('🔄 UploadResultMedia Unary Call');
        console.log('📤 Original Args:', data);
        console.log('📤 Prepared Args:', preparedData);
      }
      const response = await adminServiceClient.uploadResultMedia(preparedData);
      
      const reply = { data: TypeUtils.toPlainObject(response) };
      
      if (shouldShowDebugLogs()) {
        console.log('📥 Raw Response:', response);
        console.log('📥 Converted Reply:', reply);
        console.groupEnd();
      }
      return reply;
    } catch (error) {
      if (shouldShowDebugLogs()) {
        console.error('❌ UploadResultMedia Error:', error);
        console.groupEnd();
      }
      return { error: error instanceof Error ? error.message : 'Unknown error' };
    }
  },
};
